<template>
  <!-- XXX: Use sections as direct children of body. -->
  <div id="app">
    <!-- /img/rnd/ethynyl-radical.png -->
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  methods: {
    alertMessage() {
      this.$buefy.notification.open('Clicked!!')
    }
  }
}
</script>

<style>
/*@media (prefers-color-scheme: dark) {}*/
/*body {
  background: #e0e1db;
}*/
@font-face {
	font-family: 'blockzone';
	src: url('/fonts/blockzone-webfont.woff2') format('woff2'), url('/fonts/blockzone-webfont.woff') format('woff');
	font-weight: normal;
	font-style: normal;
}

body, button, input, select, textarea, #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  /*
  fonts:
    pixl: 'blockzone'
    typewr: 'Special Elite'
  */
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*margin-top: 60px;*/
}
</style>
